<!--系统配置 分类管理-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" clearable @clear="clearProduct"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code" clearable @clear="clearProduct" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="addNewKind" size="medium">新增分类</el-button>
        <el-button @click="exportAllProduct" type="primary" plain size="medium">导出所有</el-button>
      </el-col>
    </el-row>
    <el-row v-loading="loading" v-show="dataFalg == 1">
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="分类名称" prop="CATALOG_NAME"></el-table-column>
          <el-table-column label="储存条件" prop="STORE_CONDITION"></el-table-column>
          <el-table-column label="操作" width="300px" prop="">
            <template slot-scope="scopetable">
              <el-button type="text" @click="skuProduct(scopetable.row)">查看</el-button>
              <el-button type="text" @click="editProduct(scopetable.row)">修改</el-button>
              <el-button type="text" @click="addPoint(scopetable.row)">设置加点</el-button>
              <el-button type="text" @click="deleteProduct(scopetable.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row v-show="dataFalg == 2">
      <el-col>
        <el-table stripe border :data="productData" style="margin-top:20px">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="类别" prop="CATALOG_NAME"></el-table-column>
          <el-table-column label="安全库存" prop="SAFETY_STOCK"></el-table-column>
          <el-table-column label="出库方式" prop="">
            <template slot-scope="scopeproduct1">
              <el-tag>{{ showStock[scopeproduct1.row.OW_TYPE - 1] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="购买产品编码" prop="BUYED_PRODUCT_CODE"></el-table-column>
          <el-table-column label="购买产品名称" prop="BUYED_PRODUCT_NAME"></el-table-column>
          <el-table-column label="购买产品单位" prop="BUYED_TYPE_UNIT"></el-table-column>
          <el-table-column label="出成比例" prop="BUY_RATE"></el-table-column>
          <el-table-column label="状态" prop="">
            <template slot-scope="scopeproduct2">
              <span>{{ showStatus[scopeproduct2.row.STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column label='操作' prop="">
            <template slot-scope="scopeproduct3">
              <el-button type="text" style="color: red" v-if="scopeproduct3.row.STATUS == 1" @click="stopProduct(scopeproduct3.row)">禁用</el-button>
              <el-button type="text" v-else @click="startProduct(scopeproduct3.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增分类" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm">
            <el-form-item label="分类名称：" :label-width="formLabelWidth">
              <el-input v-model="addForm.Name"></el-input>
            </el-form-item>
            <el-form-item label="储存条件：" :label-width="formLabelWidth">
              <el-input v-model="addForm.keep"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitAdd" v-if="this.addForm.Name === ''" disabled>确 定</el-button>
            <el-button @click="submitAdd" v-else>确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改分类" center :visible.sync="editFormVisible" width="600px">
          <el-form :model="editForm" ref="editForm">
            <el-form-item label="分类名称：" :label-width="formLabelWidth">
              <el-input v-model="editForm.CATALOG_NAME"></el-input>
            </el-form-item>
            <el-form-item label="储存条件：" :label-width="formLabelWidth">
              <el-input v-model="editForm.STORE_CONDITION"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editFormVisible = false">取 消</el-button>
            <el-button @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!-- 批量导入 -->
    <el-dialog :visible.sync="inputProductDialog" title="批量导入产品" width="400px" center>
      <el-form ref="inputProductForm" v-model="inputProductForm">
        <el-upload class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove" :on-success="handleSuccess"
          :name="this.inputProductForm.inputProductName" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downProduct" style="color: #409eff; margin-top: 20px; cursor: pointer">
          点击下载导入模板
        </p>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="inputProductDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleProductList">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loadExport: false,
      // loadAdd: false,
      loading: false,
      tableData: [],
      addForm: {
        Name: '',
      },
      inputProductDialog: false,
      inputProductForm: {
        inputProductName: 'tmp',
      },
      fileList: [],
      file_name: '',
      addFormVisible: false,
      formLabelWidth: '120px',
      editForm: {},
      editFormVisible: false,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      productData: [],
      dataFalg: 1,
      showStock: ['MTO', 'MTS', 'DS'],
      searchForm: {
        name: '',
        code: '',
      },
      showStatus: ['已禁用', '在用'],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  methods: {
    // ----------------导出所有
    exportAllProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 9,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: sessionStorage.getItem('tcId'),
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 批量导入
    inputProduct() {
      this.inputProductDialog = true;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    downProduct() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/gysUsingCatalogSKUTempWithCategoryID(1).xls';
    },
    handleProductList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10050',
            OTYPE: 15,
            GYS_ID: sessionStorage.getItem('tcId'),
          };
          if (this.file_name) {
            params.FILE_NAME = this.file_name;
          } else {
            this.$message.show({ text: '请先上传文件', type: 'warning' });
            return false;
          }
          http.post(params).then((result) => {
            if (result.length == 0) {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.file_name = '';
              this.$refs.upload.clearFiles();
              this.inputProductDialog = false;
              this.queryTable();
              document.body.style.cursor = 'default';
            } else {
              this.$message.show({ text: '导入失败', type: 'error' });
              this.file_name = '';
              this.$refs.upload.clearFiles();

              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    addNewKind() {
      this.addFormVisible = true;
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    skuProduct(row) {
      this.$router.push({ path: '/kindProduct/detail' });
      sessionStorage.setItem('kindId', row.ID);
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 1,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            CATALOG_NAME: this.addForm.Name,
            STORE_CONDITION: this.addForm.keep,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增品类成功', type: 'success' });
            this.addFormVisible = false;
            this.addForm = {};
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    deleteProduct(row) {
      this.$confirm('此操作将删除分类下全部产品，并且会将分类下产品从采购列表中下架，不能继续采购, 是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10049',
          OTYPE: 2,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: sessionStorage.getItem('tcId'),
          CATALOG_ID: row.ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除品类成功', type: 'success' });
          this.queryTable();
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      }).catch(() => {
        this.$message.show({ text: '取消操作', type: 'warning' });
      });
    },
    submitEdit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 3,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            CATALOG_NAME: this.editForm.CATALOG_NAME,
            CATALOG_ID: this.editForm.ID,
            STORE_CONDITION: this.editForm.STORE_CONDITION,
          };
          if (!this.editForm.CATALOG_NAME) {
            this.$message.show({ text: '请输入分类名称', type: 'warning' });
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '修改品类成功', type: 'success' });
            this.editFormVisible = false;
            this.editForm = {};
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      this.loading = true;
      http.post(params).then((result) => {
        this.tableData = result[0].OP_ROLE;
        this.totalCount = result[0].TOTAL_COUNT;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearch() {
      if (this.searchForm.name !== '' || this.searchForm.code !== '') {
        this.dataFalg = 2;
        this.queryProduct();
      } else {
        this.dataFalg = 1;
        this.queryTable();
      }
    },
    clearProduct() {
      this.dataFalg = 1;
      this.queryTable();
    },
    queryProduct() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 12,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PRODUCT_NAME: this.searchForm.name,
        PRODUCT_CODE: this.searchForm.code,
      };
      http.post(params).then((result) => {
        this.productData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    addPoint(row) {
      this.$router.push({ path: '/kindAddPoint/detail' });
      sessionStorage.setItem('kindId', row.ID);
    },
    stopProduct(row) {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 29,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '禁用成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    startProduct(row) {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 30,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '启用成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/kindManage.vue